import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class SearchBox extends Component {
  handleChange = (e) => this.props.onChange(e.target.value);

  handleSearch = (e) => {
    e.preventDefault();
    this.props.onSearch();
  };

  render() {
    const { t } = this.props;
    return (
      <form onSubmit={this.handleSearch}>
        <div className="flex search-wrapper">
          <input
            type="search"
            className="w-full form-field"
            value={this.props.searchTerm}
            placeholder={titleize(t('SEARCH'))}
            onChange={this.handleChange}
          />
          <button
            type="submit"
            title={t('SEARCH_ORDERS')}
            className="flex items-center search-icon button button-green"
            onClick={this.handleSearch}
          >
            <i className="fa fa-search" />
          </button>
        </div>
      </form>
    );
  }
}

SearchBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
};

export default withTranslation()(SearchBox);
